import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { PROOFREADER_ROLE_EDITOR_SUBMIT_URL } from '../../../../constants/ApiUrlConstants';
import { ALL_FILE_ROUTE } from '../../../../constants/RouteNameConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import history from '../../../../features/history';
import { ProofreaderRoleEditorSubmitFailure, ProofreaderRoleEditorSubmitSuccess } from '../actions';

const proofreaderRoleEditorSubmitAPI = (action) => postApiRequest(PROOFREADER_ROLE_EDITOR_SUBMIT_URL, action);

function forwardTo(location) {
  history.push(location);
}

function* handleProofreaderRoleEditorSubmit(action) {
  try {
    const response = yield call(proofreaderRoleEditorSubmitAPI, action.payload);
    if (response?.data?.success) {
      yield call(forwardTo, ALL_FILE_ROUTE);
    }
    if (response?.data?.success && response?.data?.resultMessage !== '') {
      toast.success(response?.data?.resultMessage);
    }
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(ProofreaderRoleEditorSubmitSuccess(response));
  } catch (error) {
    yield put(ProofreaderRoleEditorSubmitFailure(error));
  }
}

export function* watchProofreaderRoleEditorSubmit() {
  yield takeLatest(types.PROOFREADER_ROLE_EDITOR_SUBMIT_REQUEST, handleProofreaderRoleEditorSubmit);
}
